import { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { formatedDate, getNextDayFormatted } from "../../services/hooks/formatedDate";
import PaymentForm from "../../components/paymentForm/PaymentForm";
import { getSubscriptData, /*interesedByPremiumSubs,*/ switchBackToBasicSubscription } from "../../services/callAPI/toSubscription";
import { ErrorOccurred } from "../../services/utils/ErrorOccurred";
import ValidToast from "../../components/toasts/ValidToast";
import UnvalidToast from "../../components/toasts/UnvalidToast";
// import { useSelector } from "react-redux";
// import { RootState } from "../../store";
import { SpinnerC } from "../../components/spinners/SpinnerC";

// Charger la clé publique Stripe
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY || "");

/* main component */
interface ISubscriptionPageProps {
  id: number;
  type: string;
  subs_start: string;
  subs_end: string;
  next_payment: string;
  isWantPremiumSubs: boolean
}

function SubscriptionPage() {
  //states
  const [paymentVisible, setisPaymentVisible] = useState(false);
  const [userSubscription, setUserSubscription] = useState<ISubscriptionPageProps>();
  const [error, setError] = useState<boolean>(false);
  const [showUnvalidToast, setshowUnvalidToast] = useState<boolean>(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [triggerUseEffect, setTriggerUseEffect] = useState<boolean>(false);
  const [alsoSwitchToBasic, setalsoSwitchToBasic] = useState<boolean>(false);
  const [switchToBasicSucess, setswitchToBasicSucess] = useState<boolean>(false);
  const [isLoading, setisLoading] = useState<boolean>(false);
  const [_loadingInteres, _setLoadingInteres] = useState(false);
  const [successInteres, setSuccessInteres] = useState(false);

  //get user role via redux
  // const userRole = useSelector((state: RootState) => state.user.role);

  //functions
  const handleRadioChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.id === 'Premium') {
      // Afficher le formulaire de paiement Stripe
      setisPaymentVisible(true);
    }
    else if (event.target.id === 'Basic') {
      try {
        //call API to switch to Basic
        await switchBackToBasicSubscription(userSubscription?.id);
        setswitchToBasicSucess(true);
      } catch (error) {
        // Gérer les différents types d'erreurs
        if (error instanceof Error) {
          // Afficher une notification ou un message d'erreur à l'utilisateur
          if (error.message === "Erreur 500 : L'abonnement a déjà une demande de retour au type Basic en cours.") {
            setalsoSwitchToBasic(true);
          }
        }
        else {
          // Message générique si le type d'erreur n'est pas identifié
          alert('Une erreur inattendue est survenue.');
        }
      }
    }
    else {
      // Masquer le formulaire si l'utilisateur choisit "Gratuit"
      setisPaymentVisible(false);
    };
  }

  // functions to payments
  const handlePaymentSuccess = () => {
    setisPaymentVisible(false); // Masquer le formulaire après un paiement réussi

    setPaymentSuccess(true);

    setTriggerUseEffect(!triggerUseEffect)
  };

  const handlePaymentFailure = () => {
    setisPaymentVisible(false); // Masquer le formulaire après un paiement réussi

    setshowUnvalidToast(true);
  }

  const handleError = () => {
    setError(true);

    const timerError = setTimeout(() => {
      setError(false);
      setTriggerUseEffect(!triggerUseEffect);
    }, 3000);

    // Nettoyage si le composant est démonté avant la fin du délai
    return () => clearTimeout(timerError);
  }

  //handleGetSubscriptData
  useEffect(() => {
    //enable loading
    setisLoading(true);

    const handleGetSubscriptData = async () => {
      try {
        const subscriptionData = await getSubscriptData();

        setUserSubscription(subscriptionData);
        setError(false);
      } catch (error) {
        setError(true);
      }
      finally {
        setisLoading(false);
      }
    }
    handleGetSubscriptData();
  }, [triggerUseEffect]);

  // const handleExpressInterest = async () => {
  //   setLoadingInteres(true);
  //   try {
  //     //call api
  //     await interesedByPremiumSubs();

  //     setSuccessInteres(true);

  //     setTriggerUseEffect(prev => !prev);
  //   } catch (error) {
  //     alert('Une erreur est survenue.');
  //   } finally {
  //     setLoadingInteres(false);
  //   }
  // };

  if (error) {
    return <ErrorOccurred />
  } else if (userSubscription) {
    return (
      <Elements stripe={stripePromise}>

        {paymentSuccess && <ValidToast message="Le Paiement est réussi . Abonnement mis à jour !" />}
        {showUnvalidToast && <UnvalidToast message="Echec du paiement !" />}
        {switchToBasicSucess && <ValidToast message="Demande prise en compte !" onClose={() => setswitchToBasicSucess(false)} />}
        {alsoSwitchToBasic && <UnvalidToast message="Demande déja prise en compte !" onClose={() => setalsoSwitchToBasic(false)} />}
        {successInteres && <ValidToast message="Merci. Votre ton intérêt est pris en compte!" onClose={() => setSuccessInteres(false)} />}
        <div className="my-4">
          <section id="manage-subscrip" className="flex flex-col items-center justify-center h-full mb-14">

            <div id="div-manage-subs" className="w-full sm:w-2/3 md:w-1/2 bg-gray-100 rounded-lg flex flex-col items-center py-6 px-4">

              <h2 className="font-bold text-lg lg:text-xl mb-3">Mon abonnement Cemade</h2>

              {/* subscription type */}
              <p>Tu bénéficies de l'offre <strong>{userSubscription.type}</strong> depuis le {userSubscription ? formatedDate(userSubscription?.subs_start) : undefined}.</p>

              <span className="border-t border-gray-300 block w-11/12 my-4" />

              {/* subscription renewval */}
              {
                userSubscription.type === "BASIC" ?
                  (
                    <>
                      <h3 className="font-bold lg:text-lg">L'abonnement sera renouvelé le</h3>
                      <p>{getNextDayFormatted(userSubscription.subs_end)} gratuitement</p>
                      <span className="border-t border-gray-300 block w-11/12 my-4" />
                    </>
                  ) :
                  (
                    <>
                      <h3 className="font-bold lg:text-lg">Renouvellement</h3>
                      <p>le {userSubscription.next_payment ? getNextDayFormatted(userSubscription?.subs_end) : undefined} à 2.99 €.</p>
                      <span className="border-t border-gray-300 block w-11/12 my-4" />
                    </>
                  )
              }

              <h3 className="font-bold pb-2 lg:text-lg">Tu souhaites changer d'offre ?</h3>

              {/* section: select subscription type */}
              <ul className="flex flex-wrap w-1/2 justify-around gap-4">
                {/* free subscription */}
                <li
                  className={`${userSubscription.type === "BASIC" ? "cursor-not-allowed" : "cursor-pointer"} flex flex-col border border-orangeCustom rounded py-2 px-4 ${userSubscription?.type === "BASIC" ? "opacity-70" : ""}`}
                  onClick={() => {
                    if (userSubscription?.type !== "BASIC") {
                      handleRadioChange({ target: { id: "Basic" } } as React.ChangeEvent<HTMLInputElement>);
                    }
                  }}
                >
                  <div className="flex items-center space-x-4">
                    <input
                      style={{
                        backgroundColor: userSubscription.type === "BASIC" ? "#E09F3E" : undefined
                      }}
                      className="border-orangeCustom appearance-none checked:bg-orangeCustom checked:border-orangeCustom cursor-pointer"
                      type="radio"
                      checked={userSubscription?.type === "BASIC"}
                      disabled={userSubscription?.type === "BASIC"}
                      id="Basic"
                      name="offer"
                      onChange={handleRadioChange}
                    />
                    <label
                      className={`${userSubscription.type === "BASIC" ? "cursor-not-allowed" : "cursor-pointer"} font-bold`}
                      htmlFor="Basic"
                    >
                      Basic
                    </label>
                  </div>
                  <span className="text-gray-500 block text-sm">Gratuit</span>
                </li>

                {/* premium subscription */}
                <li
                  className={`${userSubscription.type === "PREMIUM" ? "cursor-not-allowed" : "cursor-pointer"} flex flex-col border border-orangeCustom rounded py-2 px-4 ${userSubscription?.type === "PREMIUM" ? "opacity-70" : ""}`}
                  onClick={() => {
                    if (userSubscription?.type !== "PREMIUM") {
                      handleRadioChange({ target: { id: "Premium" } } as React.ChangeEvent<HTMLInputElement>);
                    }
                  }}
                >
                  <div className="flex items-center space-x-4">
                    <input
                      style={{
                        backgroundColor: userSubscription.type === "PREMIUM" ? "#E09F3E" : undefined
                      }}
                      id="Premium"
                      type="radio"
                      name="offer"
                      className={`${userSubscription.type === "PREMIUM" ? "cursor-not-allowed" : "cursor-pointer"} border-orangeCustom appearance-none checked:bg-orangeCustom checked:border-orangeCustom`}
                      checked={userSubscription?.type === "PREMIUM"}
                      disabled={userSubscription?.type === "PREMIUM"}
                      onChange={handleRadioChange}
                    />
                    <label
                      className={`${userSubscription.type === "PREMIUM" ? "cursor-not-allowed" : "cursor-pointer"} font-bold`}
                      htmlFor="Premium"
                    >
                      Premium
                    </label>
                  </div>
                  <span className="text-gray-500 block text-sm text-center">2.99€/mois</span>
                </li>
              </ul>

              <span className="border-t border-gray-300 block w-11/12 my-4" />

              {/* stripe payment form */}
              {paymentVisible && (
                <div className="m-2 flex flex-col justify-center items-center">

                  <PaymentForm onSuccess={handlePaymentSuccess} onFailure={handlePaymentFailure} onError={handleError} />

                  <button
                    type="button"
                    className="text-red-500 hover:underline"
                    onClick={() => setisPaymentVisible(false)}
                  >
                    Retour
                  </button>

                  <span className="border-t border-gray-300 block w-11/12 my-4" />

                </div>
              )}

              {/* section payment type */}
              <h3 className="font-bold">Moyen de paiment</h3>
              <p>via Stripe</p>

            </div>

          </section>
        </div>
      </Elements>
    )
  } else if (!isLoading) {
    return null;
  } else if (isLoading) {
    return (
      <>
        <SpinnerC></SpinnerC>
        <p>Chargement des données...</p>
      </>
    )
  } else {
    return (
      <>
        <p>Oups quelque chose s'est mal passé... </p>
      </>
    )
  }
}
export default SubscriptionPage;